import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@modernhealth/web-analytics';

import { navigationService } from 'src/config/rootService';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';

import BannerCard from 'src/shared/components/BannerCard';

interface BenefitsBannerCardProps {
    companyName: string;
}

const BenefitsBannerCard: React.FC<BenefitsBannerCardProps> = ({ companyName }) => {
    const { t } = useTranslation();
    const { companySegments, companySegment } = useSelector(getUserInformation);
    const analytics = useAnalytics();

    const handleBenefitsBanner = () => {
        if (!!companySegment || companySegments?.length === 0) {
            navigationService.navigate('/all-your-benefits');
            analytics.trackClick('homepage: explore your benefits', {
                home_section: 'explore_your_benefits',
            });
        } else {
            navigationService.navigate('/choose-your-segment');
            analytics.trackClick('homepage: explore your benefits', {
                home_section: 'choose_your_segment',
            });
        }
    };
    return (
        <BannerCard
            title={t('dashboard:explore_benefits.title')}
            description={t('dashboard:explore_benefits.sub_title', { company: companyName })}
            imageSrc="https://assets.joinmodernhealth.com/benefits/benefits-banner-web.svg"
            buttonCopy={t('dashboard:explore_benefits.button')}
            onClick={handleBenefitsBanner}
        />
    );
};

export default BenefitsBannerCard;
